(() => {
  if (window.mbrSharedReviewsPosition) {
    window.mbrSharedReviewsPosition();
    return;
  }

  // Keep Shopify section wrappers as siblings, including in the theme editor.
  const positionReviews = () => {
    const main = document.getElementById('MainContent');
    const reviews = document.getElementById('shopify-section-mbr-approved-reviews');
    const slot = main?.querySelector('[data-mbr-shared-reviews-slot]');
    const target = slot?.closest('.shopify-section');
    if (!main || !reviews || !target || target.parentElement !== main) return;
    if (target.previousElementSibling !== reviews) {
      main.insertBefore(reviews, target);
    }
  };

  window.mbrSharedReviewsPosition = positionReviews;
  positionReviews();
  document.addEventListener('DOMContentLoaded', positionReviews, { once: true });
  document.addEventListener('shopify:section:load', positionReviews);
  document.addEventListener('shopify:section:reorder', positionReviews);
})();
